import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function Filter4Icon(props: IconProps) {
    return <Icon {...props} iconKey={"filter_4"}/>
}
